/* ═══════════════════════ REISEVAKT ═══════════════════════
   Vei- og hendelsesvarsler langs ruten (DriveBC + 511 Alberta),
   aggregert server-side i /api/alerts. Cachet lokalt for offline.
════════════════════════════════════════════════════════════════ */
import { S } from './state.js';
import { esc } from './utils.js';

const LS = "ca26_alerts_v1";
export const ALERTS = { data: null, loading: false, error: false, fetchedAt: 0 };

try { const c = JSON.parse(localStorage.getItem(LS) || "null"); if (c) { ALERTS.data = c.data; ALERTS.fetchedAt = c.fetchedAt || 0; } } catch {}

export async function loadAlerts(force) {
  if (ALERTS.loading) return;
  const fresh = Date.now() - ALERTS.fetchedAt < 15 * 60 * 1000;
  if (!force && fresh && ALERTS.data) return;
  ALERTS.loading = true; ALERTS.error = false;
  if (S.tab === "idag" && window.renderPage) window.renderPage();
  try {
    const r = await fetch("/api/alerts");
    if (!r.ok) throw new Error("http " + r.status);
    ALERTS.data = await r.json();
    ALERTS.fetchedAt = Date.now();
    try { localStorage.setItem(LS, JSON.stringify({ data: ALERTS.data, fetchedAt: ALERTS.fetchedAt })); } catch {}
  } catch { ALERTS.error = true; }
  ALERTS.loading = false;
  if (S.tab === "idag" && window.renderPage) window.renderPage();
}

export function reloadAlerts() { loadAlerts(true); }

const icon = (a) => a.fire ? "🔥" : a.closed ? "⛔" : a.severity === "MAJOR" ? "⚠️" : "🚧";

export function renderAlertsCard() {
  const d = ALERTS.data;
  if (!d && !ALERTS.loading && !ALERTS.error) loadAlerts();
  const all = d?.alerts || [];
  const key = all.filter(a => a.fire || a.closed || a.severity === "MAJOR");
  const showAll = !!S.alertsAll;
  const show = (showAll ? all : key).slice(0, showAll ? 60 : 6);
  const stamp = ALERTS.fetchedAt ? new Date(ALERTS.fetchedAt).toLocaleTimeString("nb-NO", { hour: "2-digit", minute: "2-digit" }) : "";
  const head = `<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px">
      <div style="font-size:12px;font-weight:800;color:var(--gold);letter-spacing:.3px">🚦 Reisevakt <span style="font-weight:500;color:var(--t3)">· vei &amp; hendelser på ruten</span></div>
      <button onclick="reloadAlerts()" title="Oppdater" style="background:none;border:none;color:var(--t3);cursor:pointer;font-size:14px;line-height:1">🔄</button>
    </div>`;

  if (!d && ALERTS.loading) return `<div class="card" style="margin-bottom:12px">${head}<div style="font-size:12px;color:var(--t3)">Henter varsler…</div></div>`;
  if (!d && ALERTS.error) return `<div class="card" style="margin-bottom:12px">${head}<div style="font-size:12px;color:var(--t3)">Varsler er utilgjengelige nå (offline eller feil). Prøv 🔄 når du har nett.</div></div>`;
  if (!d) return `<div class="card" style="margin-bottom:12px">${head}<div style="font-size:12px;color:var(--t3)">Henter varsler…</div></div>`;

  if (!key.length && !showAll) {
    return `<div class="card" style="margin-bottom:12px">${head}
      <div style="font-size:12.5px;color:var(--green);font-weight:600">✅ Ingen store hendelser eller stengninger på ruten nå.</div>
      <div style="display:flex;justify-content:space-between;align-items:center;margin-top:8px">
        <span style="font-size:10.5px;color:var(--t3)">${stamp ? "Oppdatert " + stamp : ""}</span>
        ${all.length ? `<button onclick="S.alertsAll=true;renderPage()" style="background:none;border:none;color:var(--sky);font-size:11.5px;font-weight:600;cursor:pointer">Vis alle ${all.length} mindre varsler →</button>` : ""}
      </div></div>`;
  }

  return `<div class="card" style="margin-bottom:12px">${head}
    ${show.map(a => `<div style="display:flex;gap:9px;padding:7px 0;border-bottom:1px solid var(--border)">
      <div style="font-size:16px;flex-shrink:0;line-height:1.3">${icon(a)}</div>
      <div style="flex:1;min-width:0">
        <div style="font-size:12.5px;font-weight:700;color:var(--t1)">${esc(a.road || a.headline)} <span style="font-size:9.5px;color:var(--t3);font-weight:600">${esc(a.src)}</span></div>
        ${a.desc ? `<div style="font-size:11px;color:var(--t2);line-height:1.5;margin-top:1px">${esc(a.desc.slice(0, 150))}${a.desc.length > 150 ? "…" : ""}</div>` : ""}
      </div>
    </div>`).join("")}
    <div style="display:flex;justify-content:space-between;align-items:center;margin-top:8px">
      <span style="font-size:10.5px;color:var(--t3)">${stamp ? "Oppdatert " + stamp + " · " : ""}${all.length} varsler totalt</span>
      ${(all.length > show.length || showAll) ? `<button onclick="S.alertsAll=${!showAll};renderPage()" style="background:none;border:none;color:var(--sky);font-size:11.5px;font-weight:600;cursor:pointer">${showAll ? "Vis færre" : "Vis alle " + all.length + " →"}</button>` : ""}
    </div>
    <div style="font-size:10px;color:var(--t3);margin-top:7px;line-height:1.5">Kilder: DriveBC (Open511) &amp; 511 Alberta. Sjekk alltid offisiell kilde før avreise.</div>
  </div>`;
}
